import React from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import { MdDescription } from "react-icons/md";

////////Icono INFORMACION////////////////
const Informacion = "/informacion.svg";
////////Estilos/////////
const useStyles = makeStyles((theme) => ({
  icono: {
    width: "4em",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    zIndex: 999,
  },
}));
const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);
export default function Alertainfo({ info }) {
  const classes = useStyles();
  /*   //Popover
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (event) => {
    setAnchorEl(null);
  };
  const open2 = Boolean(anchorEl); */
  /////fin popover///////

  return (
    <div className={classes.icono}>
      {/*       <LightTooltip title="informacion" placement="left" arrow>
       */}{" "}
      <MdDescription />
      {/*       </LightTooltip>
       */}{" "}
    </div>
  );
}
